import { SET_DOC_META } from 'constants/reduxActions';

export const setDocMeta = documentMeta => ({
  type: SET_DOC_META,
  documentMeta
});
